import $ from "jquery";

const myProfile = () => {
    if (!document.getElementById('profile-page')) return;

    const el = {
        profilePage: '#profile-page',
        formProfile: '#form-profile',
        firstName: '#first-name',
        lastName: '#last-name',
        displayName: '#display-name',
        email: '#email',
        currentPassword: '#current-password',
        newPassword: '#new-password',
        confirmNewPassword: '#confirm-new-password',
        errFirstName: '#error-first-name',
        errLastName: '#error-last-name',
        errDisplayName: '#error-display-name',
        errEmail: '#error-email',
        errCurrentPassword: '#error-current-password',
        errNewPassword: '#error-new-password',
        errConfirmPassword: '#error-confirm-new-password',
    };

    const init = () => {
        bindProfile();
        checkUrlErrors();
    };

    // Check URL errors on load
    const checkUrlErrors = () => {
        const params = new URLSearchParams(window.location.search);

        if (params.get('password_error')) {
            $(el.currentPassword).addClass('is-error');
            $(el.errCurrentPassword).text('Aktuelles Passwort ist falsch.').addClass('is-visible');
            window.history.replaceState({}, '', window.location.pathname);
        }
    };

    // Validation
    const clearErrors = () => {
        Object.values(el).forEach(selector => {
            if (selector.startsWith('#error-')) {
                $(selector).text('').removeClass('is-visible');
            }
        });
        $(el.firstName).removeClass('is-error');
        $(el.lastName).removeClass('is-error');
        $(el.displayName).removeClass('is-error');
        $(el.email).removeClass('is-error');
        $(el.currentPassword).removeClass('is-error');
        $(el.newPassword).removeClass('is-error');
        $(el.confirmNewPassword).removeClass('is-error');
    };

    const validateProfile = () => {
        let valid = true;
        clearErrors();

        if (!$(el.firstName).val().trim()) {
            $(el.errFirstName).text('Bitte Vorname eingeben.').addClass('is-visible');
            $(el.firstName).addClass('is-error');
            valid = false;
        }

        if (!$(el.lastName).val().trim()) {
            $(el.errLastName).text('Bitte Nachname eingeben.').addClass('is-visible');
            $(el.lastName).addClass('is-error');
            valid = false;
        }

        if (!$(el.displayName).val().trim()) {
            $(el.errDisplayName).text('Bitte Nutzername eingeben.').addClass('is-visible');
            $(el.displayName).addClass('is-error');
            valid = false;
        }

        const emailVal = $(el.email).val().trim();
        if (emailVal && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
            $(el.errEmail).text('Bitte gültige E-Mail eingeben.').addClass('is-visible');
            $(el.email).addClass('is-error');
            valid = false;
        }

        const currentPass = $(el.currentPassword).val();
        const newPass = $(el.newPassword).val();
        const confirmNewPass = $(el.confirmNewPassword).val();
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/;

        const wantsToChangePassword = currentPass || newPass || confirmNewPass;

        if (wantsToChangePassword) {
            if (!currentPass) {
                $(el.errCurrentPassword).text('Bitte aktuelles Passwort eingeben.').addClass('is-visible');
                $(el.currentPassword).addClass('is-error');
                valid = false;
            }

            if (newPass || confirmNewPass) {
                if (!newPass) {
                    $(el.errNewPassword).text('Bitte neues Passwort eingeben.').addClass('is-visible');
                    $(el.newPassword).addClass('is-error');
                    valid = false;
                } else if (newPass.includes(' ')) {
                    $(el.errNewPassword).text('Leerzeichen sind nicht erlaubt.').addClass('is-visible');
                    $(el.newPassword).addClass('is-error');
                    valid = false;
                } else if (!regex.test(newPass)) {
                    $(el.errNewPassword).text('Passwort erfüllt nicht die Anforderungen.').addClass('is-visible');
                    $(el.newPassword).addClass('is-error');
                    valid = false;
                }

                if (!confirmNewPass) {
                    $(el.errConfirmPassword).text('Bitte Passwort bestätigen.').addClass('is-visible');
                    $(el.confirmNewPassword).addClass('is-error');
                    valid = false;
                } else if (newPass !== confirmNewPass) {
                    $(el.errConfirmPassword).text('Passwörter stimmen nicht überein.').addClass('is-visible');
                    $(el.confirmNewPassword).addClass('is-error');
                    valid = false;
                }
            }
        }

        return valid;
    };

    const bindProfile = () => {
        $(el.formProfile).on('submit', (e) => {
            if (!validateProfile()) {
                e.preventDefault();
            }
        });
    };

    init();
};

try {
    myProfile();
} catch (error) {
    console.error('my-profile', error);
}